import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RootState } from '@greenkub-fronts/shared/interface';

export interface ProtectedRouteProps {
  children: React.ReactElement;
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { children } = props;

  const { isLoggedIn, token, user, role } = useSelector(
    (store: RootState) => store.auth
  );

  // Ping Activity
  // A placer uniquement pour les routes connecté
  // useEffect(() => {
  //   ping();
  //   let interval: any = null;
  //   // interval = setInterval(ping, 1000 * 60) // toutes les 5mn
  //   interval = setInterval(ping, 1000 * 60 * 5); // toutes les 5mn
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  // const pingHandler = () => {
  //     ping()
  // };

  if (!isLoggedIn || !token) {
    return <Navigate to={'/login'} />;
  }

  if (
    role === 'CUSTOMER' &&
    import.meta.env.VITE_CURRENT_FRONT_URL === import.meta.env.VITE_CRM_URL
  ) {
    localStorage.removeItem('auth');
    window.location.replace(import.meta.env.VITE_CUSTOMER_AREA_URL + '/login');
  }

  return children;
};

export default ProtectedRoute;
